<template>
    <div
        :class="
            setClass && setClass.length
                ? 'size_img_17 text_alignment_main_box_custom'
                : 'addtext_font align_value text_alignment_main_box_custom arrow_align'
        "
    >
        <div class="form-group">
            <div class="layer_parent_div left_margin_zero">
                <button
                    @click="setValue('left')"
                    class="bcommon b1 large active first"
                >
                    <img src="./icon/left1.png" />
                </button>
                <button @click="setValue('center')" class="bcommon">
                    <img
                        class="center_img"
                        src="./icon/cneter_s.svg"
                        :style="'' + (!showLabel ? 'padding:6px;' : '')"
                    />
                </button>
                <button
                    @click="setValue('right')"
                    class="bcommon b2 large last"
                >
                    <img src="./icon/right1.png" />
                </button>
            </div>
        </div>
        <label v-show="showLabel">Align</label>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Center",
    /* eslint-enable */
    data: () => {
        return {};
    },
    props: ["setClass", "showLabel"],
    methods: {
        setValue(e) {
            this.$emit("set-value", e);
        },
        setActive(e) {
            console.log(e);
            return this.value ? "active" : "";
        }
    }
};
</script>

<style>
.center_img {
    height: 18px !important;
    transform: none !important;
    min-height: 14px !important;
    object-fit: initial;
    width: 34px !important;
}
</style>
